import isServer from './isServer';

const computedStyle = isServer()
  ? {}
  : window.getComputedStyle(document.documentElement);

export function getCssStyle(varName) {
  return computedStyle?.getPropertyValue?.(varName) || '';
}
